<template>
  <vf-dialog-layout class-wrapper="py-0" data-scroll-el="filtersPanel">
    <template #title>
      {{ $t.filterAndSort }}
    </template>
    <filter-pickup v-if="pickupFilters" class="b-b b-grey-70 py-4" />
    <div v-if="!Object.keys(filters).length" class="px-4 py-10 text-center md:p-20">
      <div v-if="pickupFilters && $route.query.storeFilter">
        <div class="title-2">
          {{ $t.noResultsInStore }}
        </div>
        <span class="mt-6 block">{{ $t.noResultsInStoreSubtitle }}</span>
      </div>
      <div v-else class="title-2">
        {{ $t.noResults }}
      </div>
    </div>
    <template v-else>
      <base-lazy-hydrate v-if="sortOptions?.length && total" when="interaction">
        <vf-accordion
          class-toggle="pb-1 pt-5 text-lg fw-bold"
          open
          style="border-top: 0"
          :title="$t.sort"
          variant="aligned"
        >
          <div class="grid gap-4 py-4">
            <vf-radio
              v-for="{ value, label } in sortOptions"
              :key="value"
              :model-value="sortState"
              name="sort"
              :value
              @update:model-value="$emit('sort', $event!)"
            >
              <span class="font-secondary uppercase">
                {{ label }}
              </span>
            </vf-radio>
          </div>
        </vf-accordion>
      </base-lazy-hydrate>
      <base-lazy-hydrate v-for="(filter, code) in filters" :key="`mobileFilter-${code}`" when="interaction">
        <vf-accordion
          class-toggle="pb-1 pt-5 text-lg fw-bold"
          data-scroll-el="filtersPanelAccordion"
          variant="aligned"
        >
          <template #title>
            <span class="flex items-center gap-2">
              {{ filter.label }}

              <span
                v-if="filter.selected.length"
                class="h-5 w-5 flex center rounded-full bg-grey-20 text-xs c-white"
              >
                {{ filter.selected.length }}
              </span>
            </span>
          </template>
          <div v-if="$feature.showFitFinderOnPLP && String(code).toLowerCase() === 'attr_size'" id="fit-finder-plp" class="py-6" />
          <filter-options
            class="py-4"
            :currency
            :filter
            :loading
            :model-value="filter.selected"
            @update:model-value="$emit('update', { code: `${code}`, selected: $event! })"
          />
        </vf-accordion>
      </base-lazy-hydrate>
    </template>
    <template #footer>
      <div class="grid gap-4 <md:cols-2">
        <vf-button data-test-id="dialog-filters-clear-button" variant="tertiary" @click="$emit('clear')">
          {{ $t.reset }}
        </vf-button>
        <vf-button class="md:hidden" data-test-id="dialog-filters-apply-button" @click="$emit('resolve')">
          {{ replaceAll($t.applyFilteredResults, { total }) }}
        </vf-button>
      </div>
    </template>
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { Emits as _Emits, Props as _Props } from '#commerce/components/dialog/filters/Filters.vue'

export type Emits = _Emits
export type Props = _Props
defineProps<Props>()
defineEmits<Emits>()

const { injectFitFinder } = useFitFinder()

onMounted(injectFitFinder)
</script>
